import React from "react";
import { useField } from "react-final-form";
import { GivenNameField } from "../../shared/fields";
import CurrentAccountInfo from "../current-account-info";
import { PasswordField, SecretQuestionReadonly } from "./fields";

const CoppaUpdateUserFormFields = () => {
  useField("isCoppa", {
    defaultValue: true
  });
  return (
    <>
      <CurrentAccountInfo />
      <GivenNameField />
      <PasswordField />
      <SecretQuestionReadonly />
    </>
  );
};

export default CoppaUpdateUserFormFields;
